export const DSS_ENDPOINTS = {
	departments: "categories", // to get merchendised departments. This can take query params such as @is_displayed - boolean
	products: "products",
	search: "search",
	users: "users",
	addresses: "addresses",
	orders: "orders/customer",
};
